import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { TopBarActions } from "src/redux/TopBar/actions";
import { TopBarSelectors } from "src/redux/TopBar/selectors";
import Button from "src/components/common/Button";

import styles from "./styles.module.scss";
import { ROLE } from "src/redux/TopBar/constants";

class RoleSwitch extends PureComponent {
    static propTypes = {
        role: PropTypes.string,
        SetRole: PropTypes.func,
    };

    render() {
        const { role, SetRole } = this.props;
        const roleBtnList = [ROLE.BORROWER, ROLE.LENDER];
        const roleBtns = roleBtnList.map((ele, idx) => {
            return (
                <Button
                    key={ele}
                    dataTestId={`change-role-to-${ele}`}
                    onClick={(e) => {
                        if (role !== ele) SetRole(e.target.value);
                    }}
                    value={ele}
                    classes={[ele === role ? styles.active : ""]}
                />
            );
        });

        return (
            <div className={styles.roleSwitch}>
                <div className={styles.title}>Select Side</div>
                <div className={[styles.role, styles[role]].join(" ")}>
                    {roleBtns}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    role: TopBarSelectors.Role(state),
});

const mapDispatchToProps = (dispatch) => ({
    SetRole: (role) => dispatch(TopBarActions.SetRole(role)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoleSwitch);
